import { Component } from '@angular/core';
import {TopBarComponent} from "../../top-bar/top-bar.component";
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {HeroContactComponent} from "./hero-contact/hero-contact.component";
import {FormPQRSComponent} from "./form-pqrs/form-pqrs.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";

@Component({
  selector: 'app-contactanos',
  standalone: true,
  imports: [
    TopBarComponent,
    NavBarComponent,
    HeroContactComponent,
    FormPQRSComponent,
    FooterPersonaComponent
  ],
  templateUrl: './contactanos.component.html',
  styleUrl: './contactanos.component.css'
})
export class ContactanosComponent {

}
